<div class="admin-layout-container tw-relative tw-overflow-y-auto tw-h-full">
    <div class="admin-layout-content">
        <mon-breadcrumb [model]="breadcrumbs" [showBreadcrumbs]="showBreadcrumbs"></mon-breadcrumb>
        <div ui-view ></div>
    </div>
</div>
